export const africaCountryCodes = ['BW', 'NA', 'ZM', 'ZW', 'ZA', 'RW', 'MZ', 'KE', 'MU', 'TZ', 'UG', 'LS', 'SC', 'SZ', 'MW', 'CG', 'MG'];

export const isRestOfWorld = countryCode => !africaCountryCodes.includes(countryCode);
